"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyAndDemandData = void 0;
const demand_data_response_1 = require("./demand-data.response");
const supply_data_response_1 = require("./supply-data.response");
class SupplyAndDemandData {
}
exports.SupplyAndDemandData = SupplyAndDemandData;
//# sourceMappingURL=supply-and-demand-data.response.js.map